import React, { useState, useEffect, useCallback } from "react";
import "./EpisodeList.css";
import EpisodeListFilter from "./EpisodeListFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  selectedEpisodeList,
  getFilterEpisodeLists,
  setEpisodeListFilterObj,
  resetEpisodeListFilters,
} from "./redux/EpisodeListSlicer";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import {
  Table,
  Badge,
  Spinner,
  Form,
  Pagination,
  Dropdown,
  OverlayTrigger,
} from "react-bootstrap";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Drawer,
  Divider,
  Grid,
  Button,
} from "@mui/material";
import EpisodeListMobile from "./EpisodeListMobile";
import RefershIcon from "../../../common/assets/images/reload.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  resetDocumentViewerError,
  resetEpisodeIdentifierTopassDocumentViewer,
  resetDocumentViewerLoadedData,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import {
  faSortAmountUp,
  faSortAmountDesc,
  faSortAmountDown,
  faBed,
  faUserInjured,
  faUser,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import { setRawSearchQuery } from "../../CodeBook/redux/CodeBookSlicer";
import { handleResetSelectedDetails } from "../../CodeAssist/CodeSearch/redux/codeSearchSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  setCoderFilterSearch,
  setEpisodeIdentiferFilterSearch,
  setHealthFundFilterContractSearch,
  setMRNFilterSearch,
  setPriorityFilterSearch,
  setProvisionalDrgFilterSearch,
  setQueueFilterSearch,
  setSpecialityFilterSearch,
  setStatusFilterSearch,
} from "../../Codeworkflow/HealthInsuranceManager/redux/HealthInformationManagerSlicer";

const EpisodeList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;

  //settings needed for responsive mobile
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const navigate = useNavigate();
  const currentLocation = useLocation(); // <- use a unique name

  const [episodeListRowsPerPage, setEpisodeListRowsPerPage] = useState(10);
  const [episodeListCurrentPage, setEpisodeListCurrentPage] = useState(1);
  const [showepisodeListFilter, setShowepisodeListFilter] = useState(false);
  const [selectedPatientType, setSelectedPatientType] = useState(
    episodeListFilterObj?.type_patient?.[0] || null,
  );
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const totalPages =
    typeof episodesFilterList?.total_episodes === "number" &&
    typeof episodeListFilterObj?.page_size === "number" &&
    episodeListFilterObj.page_size > 0
      ? Math.max(
          1,
          Math.ceil(
            episodesFilterList.total_episodes / episodeListFilterObj.page_size,
          ),
        )
      : 1;
  const dataToDisplay =
    episodesFilterList?.episode?.length > 0 && episodesFilterList?.episode;
  const [drgAnchorEl, setDrgAnchorEl] = useState(null);
  const [activeDrgRow, setActiveDrgRow] = useState(null);

  const openDrgMenu = (event, rowId) => {
    setDrgAnchorEl(event.currentTarget);
    setActiveDrgRow(rowId);
  };

  const closeDrgMenu = () => {
    setDrgAnchorEl(null);
    setActiveDrgRow(null);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...episodeListFilterObj,
        page: pageNumber,
      };
      dispatch(setEpisodeListFilterObj(payload));
      dispatch(getFilterEpisodeLists(payload));
    }
  };

  const getInitialFilterState = () => ({
    page: 1,
    page_size: 20,
    sort_by: [],
    sort_order: [],
    module_name: "",
    status: [],
    speciality: [],
    health_fund_contract: [],
    episode_identifier: [],
    medical_record_number: [],
    admission_from_date: null,
    admission_to_date: null,
    separation_from_date: null,
    separation_to_date: null,
    length_of_stay: [],
    los_op: "",
    document_name: [],
    drg: [],
  });

  useEffect(() => {
    sessionStorage.setItem("trackHistory", JSON.stringify([]));
    sessionStorage.setItem("redoStack", JSON.stringify([]));
    const codeAssistStatusChangePayload = {
      ...getInitialFilterState(),
      module_name: "Code Assist",
    };

    const codeAccelerateStatusChangePayload = {
      ...getInitialFilterState(),
      module_name: "Code Accelerate",
    };

    if (location.pathname === "/Code-Assist-Episode-list") {
      dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
    } else {
      dispatch(getFilterEpisodeLists(codeAccelerateStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAccelerateStatusChangePayload));
    }
  }, [location.pathname]);

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...episodeListFilterObj,
      page: 1,
      page_size: Number(event.target.value),
    };
    dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));
  };

  const sortingEpisodeHandler = (name) => {
    const currentSortBy = episodeListFilterObj.sort_by?.[0];
    const currentSortOrder = episodeListFilterObj.sort_order?.[0];

    const newSortOrder =
      currentSortBy === name && currentSortOrder === "asc" ? "desc" : "asc";

    const payload = {
      ...episodeListFilterObj,
      sort_by: [name],
      sort_order: [newSortOrder],
    };
    dispatch(getFilterEpisodeLists(payload));
    dispatch(setEpisodeListFilterObj(payload));
  };

  const getPatientTypeIcon = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return faBed;
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return faUserInjured;
    }
    return faUser; // default icon
  };

  const getPatientTypeColor = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return "#4CAF50";
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return "#2196F3";
    }
    return "#757575";
  };

  const closeEpisodeFilterModal = () => {
    setShowepisodeListFilter(false);
    setCoderSearchTerm("");
    dispatch(resetEpisodeListFilters());
    dispatch(setEpisodeIdentiferFilterSearch(""));
    dispatch(setMRNFilterSearch(""));
    dispatch(setSpecialityFilterSearch(""));
    dispatch(setQueueFilterSearch(""));
    dispatch(setCoderFilterSearch(""));
    dispatch(setPriorityFilterSearch(""));
    dispatch(setStatusFilterSearch(""));
    dispatch(setHealthFundFilterContractSearch(""));
    dispatch(setProvisionalDrgFilterSearch(""));
    const resetState = {
      page: 1,
      page_size: 20,
      sort_by: [],
      sort_order: [],
      module_name:
        location.pathname === "/Code-Assist-Episode-list"
          ? "Code Assist"
          : "Code Accelerate",
      status: [],
      speciality: [],
      health_fund_contract: [],
      episode_identifier: [],
      medical_record_number: [],
      admission_from_date: null,
      admission_to_date: null,
      separation_from_date: null,
      separation_to_date: null,
      length_of_stay: [],
      los_op: "",
      document_name: [],
      drg: [],
    };
    dispatch(setEpisodeListFilterObj(resetState));
    dispatch(getFilterEpisodeLists(resetState));
  };

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(getFilterEpisodeLists(payload));
    }, 1000),
    [],
  );
  const handleSearchTypeChange = (type) => {
    const payload = {
      ...episodeListFilterObj,
      episode_identifier: "",
      medical_record_number: "",
    };
    setSearchType(type);
    setShowOptions(false);
    dispatch(setEpisodeListFilterObj(payload));
  };

  const formatValue = (val) => {
    if (typeof val !== "string") return "";

    return val
      .trim() // remove start/end spaces
      .replace(/\s+/g, " "); // convert multiple spaces → single space
  };

  const handleEpisodeIdentiferSearch = (e) => {
    const rawValue = e.target.value;
    setCoderSearchTerm(rawValue);
    setShowOptions(false);

    const formattedValue = formatValue(rawValue);

    // const payload = {
    //   ...episodeListFilterObj,
    //   episode_identifier: searchType === "episode" ? value : "",
    //   medical_record_number: searchType === "mrn" ? value : "",
    // };

    const payload = {
      ...episodeListFilterObj,
      page: 1,
      episode_identifier:
        searchType === "episode" && formattedValue ? [formattedValue] : [],
      medical_record_number:
        searchType === "mrn" && formattedValue ? [formattedValue] : [],
    };

    // ✅ Use RAW value for UI state (if needed separately)
    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        page: 1,
        episode_identifier: searchType === "episode" ? [rawValue] : [],
        medical_record_number: searchType === "mrn" ? [rawValue] : [],
      }),
    );
    debounceSearchHandler(payload);
  };

  const renderSortIcon = (columnKey) => {
    const currentSortBy = episodeListFilterObj.sort_by?.[0];
    const currentSortOrder = episodeListFilterObj.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return faSort; // neutral
    }

    return currentSortOrder === "asc" ? faSortAmountUp : faSortAmountDown;
  };

  const getSortTooltip = (columnKey) => {
    const currentSortBy = episodeListFilterObj.sort_by?.[0];
    const currentSortOrder = episodeListFilterObj.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return "Click to sort";
    }

    return currentSortOrder === "asc"
      ? "Sorted Ascending"
      : "Sorted Descending";
  };

  return isSmallScreen ? (
    <EpisodeListMobile getInitialFilterState={getInitialFilterState} />
  ) : (
    <div className="episodelist-section">
      <div className="episodelist-header">
        <div className="episodelist-header-section">
          <h4 className="episodelist-header-text">Episode List</h4>
          <span className="episodelist-header-text-total">{`(${
            episodesFilterList?.total_episodes
              ? episodesFilterList?.total_episodes
              : 0
          })`}</span>
        </div>
        <div className="episodelist-filter-section">
          <Box sx={{ mr: 1, position: "relative" }}>
            <input
              className="episodelist-filter-episode-identifier"
              value={coderSearchTerm}
              // searchType === "episode"
              // ? episodeListFilterObj?.episode_identifier
              // : episodeListFilterObj?.medical_record_number
              // }
              placeholder={
                searchType === "episode"
                  ? "Search by Episode ID"
                  : "Search by MRN"
              }
              onFocus={() => setShowOptions(true)}
              onBlur={() => setTimeout(() => setShowOptions(false), 150)}
              onChange={handleEpisodeIdentiferSearch}
            />
            {showOptions && (
              <div className="search-options-dropdown">
                <div
                  className={`search-option ${searchType === "episode" ? "active" : ""}`}
                  onMouseDown={() => handleSearchTypeChange("episode")}
                >
                  Search by Episode ID
                </div>

                <div
                  className={`search-option ${searchType === "mrn" ? "active" : ""}`}
                  onMouseDown={() => handleSearchTypeChange("mrn")}
                >
                  Search by MRN
                </div>
              </div>
            )}
          </Box>
          <span
            className="episodelist-filter-icon"
            onClick={() => {
              setShowepisodeListFilter(!showepisodeListFilter);
              // dispatch(getEpisodeFilterOptions());
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#1f1f1f"
            >
              <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z" />
            </svg>
          </span>
          <span
            class="episodelist-refresh-btn"
            onClick={() => {
              const payload = {
                page: 1,
                page_size: 20,
                sort_order: [],
                sort_by: [],
                status: [],
                module_name: "Code Accelerate",
                health_fund_contract: [],
                speciality: [],
                medical_record_number: [],
                episode_identifier: [],
                admission_to_date: null,
                admission_from_date: null,
                separation_to_date: null,
                separation_from_date: null,
                los_op: "",
                length_of_stay: [],
                drg: [],
                document_name: [],
              };

              const codeAssistStatusChangePayload = {
                page: 1,
                page_size: 20,
                sort_order: [],
                sort_by: [],
                status: [],
                health_fund_contract: [],
                speciality: [],
                medical_record_number: [],
                episode_identifier: [],
                admission_to_date: null,
                admission_from_date: null,
                separation_to_date: null,
                separation_from_date: null,
                los_op: "",
                length_of_stay: [],
                drg: [],
                document_name: [],
                module_name: "Code Assist",
              };

              if (location.pathname === "/Code-Assist-Episode-list") {
                dispatch(
                  setEpisodeListFilterObj(codeAssistStatusChangePayload),
                );
                dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
              } else {
                dispatch(setEpisodeListFilterObj(payload));
                // dispatch(setEpisodeListFilterObj(payload));
                dispatch(getFilterEpisodeLists(payload));
              }
              setCoderSearchTerm("");
            }}
          >
            {/* <span> */}
            <img src={RefershIcon} alt="img" />
            {/* </span> */}
          </span>
        </div>
      </div>
      <div
        className="episodelist-table-container"
        style={{ overflowX: "auto" }}
      >
        <Table
          // responsive="sm"
          style={{ textAlign: "center" }}
          className={`${
            episodesFilterList?.episode?.length <= 0 ||
            episodesFilterList?.episode?.length === undefined ||
            episodesFilterListLoading ||
            episodesFilterListError
              ? "episodelist-filter-table-loading"
              : "episodelist-filter-table"
          }`}
        >
          <thead className="episodelist-thead">
            <tr className="episodelist-tr">
              {codebookusaEnv && (
                <th className="episodelist-th">
                  <div>
                    <span>Episode Type</span>
                  </div>
                </th>
              )}
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("medical_record_number")}
                >
                  <div>
                    <span>MRN/UR</span>
                  </div>
                  <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("medical_record_number")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("medical_record_number")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                  {/* <div>
                    {episodeListFilterObj.sort_by === "medical_record_number" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by ===
                        "medical_record_number" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div> */}
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("episode_identifier")}
                >
                  <div>
                    <span> Episode Number</span>
                  </div>
                  <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("episode_identifier")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("episode_identifier")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("admission_date")}
                >
                  <div>
                    <span>Admission Date</span>
                  </div>
                   <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("admission_date")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("admission_date")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("separation_date")}
                >
                  <div>
                    <span>Discharge Date</span>
                  </div>
                 <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("separation_date")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("separation_date")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("length_of_stay")}
                >
                  <div>
                    <span>LOS</span>
                  </div>
                   <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("length_of_stay")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("length_of_stay")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("speciality")}
                >
                  <div>
                    <span>Speciality</span>
                  </div>
                 <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("speciality")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("speciality")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("health_fund_contract")}
                >
                  <div>
                    <span>Health Fund</span>
                  </div>
                  <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("health_fund_contract")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("health_fund_contract")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>

              <th className="episodelist-th" style={{ minWidth: "100px" }}>
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("drg")}
                >
                  <div>
                    <span>Drg</span>
                  </div>
                   <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("drg")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("drg")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() =>
                    sortingEpisodeHandler("provisional_account_revenue")
                  }
                >
                  <div>
                    <span>Provisional Account Revenue</span>
                  </div>
                   <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("provisional_account_revenue")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("provisional_account_revenue")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              <th className="episodelist-th" style={{ minWidth: "200px" }}>
                <div
                  className="episodelist-th-container-status"
                  onClick={() => sortingEpisodeHandler("status")}
                >
                  <div>
                    <span>Status</span>
                  </div>
                  <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("status")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("status")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                </div>
              </th>
              {location.pathname != "/Code-Assist-Episode-list" && (
                <th className="episodelist-th">
                  <div
                    className="episodelist-th-container"
                    onClick={() => sortingEpisodeHandler("document_count")}
                  >
                    <div>
                      <span>No of documents</span>
                    </div>
                      <span className="episodelist-sort-icon">
                    <Tooltip
                      title={getSortTooltip("document_count")}
                      arrow
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={renderSortIcon("document_count")}
                        />
                      </span>
                    </Tooltip>
                  </span>
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody className="episodelist-body">
            {episodesFilterListLoading ? (
              <td colspan="11">
                <div className="episodelist-table-loader">
                  <Spinner />{" "}
                </div>
              </td>
            ) : episodesFilterListError ? (
              <td colspan="11">
                <div className="episodelist-table-loader">
                  Something went wrong
                </div>
              </td>
            ) : dataToDisplay?.length > 0 ? (
              dataToDisplay?.map((episode, episodeIndex) => {
                return (
                  <tr
                    key={episode.episode_number}
                    onDoubleClick={() => {
                      dispatch(setRawSearchQuery(""));
                      dispatch(handleResetSelectedDetails());
                      const currentPath = currentLocation.pathname;
                      const destinationPath =
                        currentPath === "/Code-Assist-Episode-list"
                          ? "/Code-Assist"
                          : "/coder";

                      navigate(destinationPath);
                      dispatch(resetEpisodeIdentifierTopassDocumentViewer());
                      sessionStorage.setItem("currentPage", "episodeList");
                      sessionStorage.setItem(
                        "filters",
                        JSON.stringify(episodeListFilterObj),
                      );
                      sessionStorage.setItem(
                        "last_hcp_line_id",
                        JSON.stringify(
                          episode?.hcp_line_id ? episode?.hcp_line_id : "",
                        ),
                      );
                      sessionStorage.setItem(
                        "currentEpisodeIndex",
                        episodeIndex,
                      );
                      dispatch(resetDocumentViewerLoadedData());
                      dispatch(selectedEpisodeList(episode));
                      dispatch(resetDocumentViewerError());
                    }}
                  >
                    {/* <td className="episodelist-td">
                      <Tooltip title={episode?.type_patient}>
                        {episode?.type_patient
                          ? episode?.type_patient
                          : "-"}
                      </Tooltip>
                    </td> */}
                    {codebookusaEnv && (
                      <td className="episodelist-td">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {episode?.type_patient ? (
                            <>
                              <Tooltip title={episode.type_patient}>
                                <FontAwesomeIcon
                                  icon={getPatientTypeIcon(
                                    episode.type_patient,
                                  )}
                                  style={{
                                    color: getPatientTypeColor(
                                      episode.type_patient,
                                    ),
                                    fontSize: "16px",
                                  }}
                                />
                              </Tooltip>
                              <span style={{ marginLeft: "4px" }}>
                                {/* {episode.type_patient} */}
                                {episode.type_patient.charAt(0).toUpperCase() +
                                  episode.type_patient.slice(1)}
                              </span>
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon
                                icon={faUser}
                                style={{
                                  color: "#757575",
                                  fontSize: "16px",
                                }}
                              />
                              <span style={{ marginLeft: "4px" }}>-</span>
                            </>
                          )}
                        </div>
                      </td>
                    )}
                    <td className="episodelist-td">
                      {episode.is_locked && (
                        <LockOutlineIcon
                          style={{ fontSize: "18px", marginRight: "8px" }}
                        />
                      )}
                      <Tooltip title={episode.medical_record_number}>
                        {episode.medical_record_number
                          ? episode.medical_record_number
                          : "-"}
                      </Tooltip>
                    </td>
                    <td className="episodelist-td">
                      {episode.episode_identifier
                        ? episode.episode_identifier
                        : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.admission_date ? episode.admission_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.separation_date ? episode.separation_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.length_of_stay ? episode.length_of_stay : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.speciality ? episode.speciality : "-"}
                      {/* {episode.drg === "392" ? (
                        <>
                          <Tooltip
                            title={
                              "Esophagitis, Gastroenteritis and Miscellaneous Digestive Disorders without MCC"
                            }
                          >
                            Esophagitis, Gastroenteritis and Miscellaneous
                            Digestive Disorders without MCC
                          </Tooltip>
                        </>
                      ) : episode.drg === "334" ? (
                        <Tooltip title={"Rectal Resection without CC/MCC"}>
                          Rectal Resection without CC/MCC
                        </Tooltip>
                      ) : episode.drg === "331" ? (
                        <Tooltip
                          title={
                            "Major Small and Large Bowel Procedures without CC/MCC"
                          }
                        >
                          Major Small and Large Bowel Procedures without CC/MCC
                        </Tooltip>
                      ) : episode.drg === "462" ? (
                        <Tooltip
                          title={
                            "Bilateral or Multiple Major Joint Procedures of Lower Extremity without MCC"
                          }
                        >
                          Bilateral or Multiple Major Joint Procedures of Lower
                          Extremity without MCC
                        </Tooltip>
                      ) : episode.drg === "502" ? (
                        <Tooltip
                          title={"Soft Tissue Procedures without CC/MCC"}
                        >
                          Soft Tissue Procedures without CC/MCC
                        </Tooltip>
                      ) : (
                        "-"
                      )} */}
                    </td>
                    <td className="episodelist-td">
                      {episode.health_fund_contract
                        ? episode.health_fund_contract
                        : "-"}
                    </td>
                    {/* <td className="episodelist-td">
                      {episode.created_at ? episode.created_at : "-"}
                    </td> */}
                    <td
                      className={`episodelist-td ${
                        episode.status === "Coding Complete" ||
                        episode.status === "aCS Coding Complete"
                          ? "episodelist-td-min-bold-drg"
                          : episode.status === "AI codes awaiting validation" &&
                              episode.drg !== "No DRG"
                            ? "episodelist-td-bold-drg"
                            : "episodelist-td-normal-drg"
                      }`}
                    >
                      {(() => {
                        const drgs = episode?.drg_codes || [];
                        if (!drgs.length) return "-";

                        const defaultDrg =
                          drgs.find((drg) => drg.is_default) || drgs[0];

                        const remainingDrgs = drgs.filter(
                          (drg) => drg !== defaultDrg && drg.drg_code,
                        );
                        console.log(
                          drgs,
                          remainingDrgs,
                          "remainingDrgsremainingDrgs",
                        );

                        return (
                          <>
                            {/* Default DRG */}
                            <Tooltip
                              title={
                                <>
                                  <div>
                                    <b>Grouper Version:</b>{" "}
                                    {defaultDrg.grouper_version}
                                  </div>
                                </>
                              }
                              arrow
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  fontWeight: 500,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "2px",
                                }}
                                onClick={(e) =>
                                  openDrgMenu(e, episode.episode_identifier)
                                }
                              >
                                {defaultDrg.drg_code}
                                {remainingDrgs.length > 0 && (
                                  <ArrowDropDownIcon fontSize="small" />
                                )}
                              </span>
                            </Tooltip>

                            {/* Dropdown Menu */}
                            <Menu
                              anchorEl={drgAnchorEl}
                              open={
                                Boolean(drgAnchorEl) &&
                                activeDrgRow === episode.episode_identifier
                              }
                              PaperProps={{
                                elevation: 1,
                                sx: {
                                  boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                                  borderRadius: "6px",
                                  mt: 0.5,
                                },
                              }}
                              onClose={closeDrgMenu}
                            >
                              {remainingDrgs.map((drg, index) => (
                                <Tooltip
                                  key={index}
                                  title={
                                    <>
                                      <div>
                                        <b>Version:</b> {drg.grouper_version}
                                      </div>
                                      <div>
                                        <b>DRG:</b> {drg.drg_code}
                                      </div>
                                    </>
                                  }
                                  placement="right"
                                  arrow
                                >
                                  <MenuItem
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{
                                      cursor: "default",
                                      pointerEvents: "auto",
                                    }}
                                  >
                                    {drg.drg_code}
                                  </MenuItem>
                                </Tooltip>
                              ))}
                            </Menu>
                          </>
                        );
                      })()}
                    </td>
                    <td className="episodelist-td">
                      {(() => {
                        const drgs = episode?.drg_codes || [];
                        if (!drgs.length) return "-";

                        const defaultDrg =
                          drgs.find((drg) => drg.is_default) || drgs[0];

                        return (
                          <>
                            <span
                              style={{
                                cursor: "pointer",
                                fontWeight: 500,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              ${" "}
                              {Math.round(
                                defaultDrg.weight * 6465,
                              ).toLocaleString()}
                            </span>
                          </>
                        );
                      })()}
                    </td>

                    <td className="episodelist-td-status">
                      {(() => {
                        // Convert status to array if API returns single object/string
                        const statuses = Array.isArray(episode?.status)
                          ? episode.status
                          : episode?.status
                            ? [episode.status]
                            : [];

                        // Find primary status
                        const primaryStatus =
                          statuses.find((item) => item?.is_primary) ||
                          statuses[0];

                        // Remaining statuses (shown only in tooltip)
                        const secondaryStatuses = statuses.filter(
                          (item) => item !== primaryStatus,
                        );

                        return (
                          <Tooltip
                            title={
                              <div style={{ padding: "4px 8px" }}>
                                {statuses.map((item, index) => (
                                  <div key={index}>{item.status}</div>
                                ))}
                              </div>
                            }
                            arrow
                            placement="top"
                          >
                            <Box>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  cursor:
                                    statuses.length > 1 ? "pointer" : "default",
                                }}
                              >
                                {/* Secondary statuses shown as stacked background layers */}
                                {secondaryStatuses
                                  .slice(0, 2)
                                  .map((_, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        position: "absolute",
                                        top: `${(index + 1) * 3}px`,
                                        left: `${(index + 1) * 3}px`,
                                        right: `${-(index + 1) * 3}px`,
                                        bottom: `${-(index + 1) * 3}px`,
                                        backgroundColor: "#d1d5db",
                                        borderRadius: "6px",
                                        zIndex: index,
                                        opacity: 0.6,
                                      }}
                                    />
                                  ))}

                                {/* Primary status shown in front */}
                                <Badge
                                  ref={(badge) => {
                                    if (badge) {
                                      badge.style.setProperty(
                                        "background-color",
                                        episode?.status_color || "#dbeafe",
                                        "important",
                                      );
                                      badge.style.setProperty("color", "black");
                                      badge.style.setProperty(
                                        "display",
                                        "flex",
                                      );
                                      badge.style.setProperty(
                                        "align-items",
                                        "center",
                                      );
                                      badge.style.setProperty(
                                        "justify-content",
                                        "center",
                                      );
                                      badge.style.setProperty(
                                        "min-height",
                                        "30px",
                                      );
                                      badge.style.setProperty("width", "100%");
                                      badge.style.setProperty(
                                        "font-size",
                                        "11px",
                                      );
                                      badge.style.setProperty(
                                        "padding",
                                        "4px 8px",
                                      );
                                      badge.style.setProperty(
                                        "white-space",
                                        "normal",
                                      );
                                      badge.style.setProperty(
                                        "word-break",
                                        "break-word",
                                      );
                                      badge.style.setProperty(
                                        "text-align",
                                        "center",
                                      );
                                      badge.style.setProperty(
                                        "border-radius",
                                        "6px",
                                      );
                                      badge.style.setProperty(
                                        "box-shadow",
                                        "0 4px 10px rgba(0, 0, 0, 0.15)",
                                      );
                                      badge.style.setProperty(
                                        "position",
                                        "relative",
                                      );
                                      badge.style.setProperty("z-index", "10");
                                    }
                                  }}
                                >
                                  {primaryStatus?.display_value ||
                                    primaryStatus?.status ||
                                    "-"}
                                </Badge>
                              </div>
                            </Box>
                          </Tooltip>
                        );
                      })()}
                    </td>
                    {/* <td className="episodelist-td-status">
                      <Badge
                        ref={(badge) => {
                          if (badge) {
                            badge.style.setProperty(
                              "background-color",
                              episode?.status_color,
                              "important",
                            );
                            badge.style.setProperty("display", "flex");
                            {
                              episode.status === "AI codes awaiting validation"
                                ? badge.style.setProperty("color", "black")
                                : badge.style.setProperty("color", "black");
                            }
                            badge.style.setProperty("align-items", "center");
                            badge.style.setProperty(
                              "justify-content",
                              "center",
                            );
                            badge.style.setProperty("height", "30px");
                            badge.style.setProperty("width", "100%");
                            badge.style.setProperty("font-size", "11px");
                            badge.style.setProperty("white-space", "normal"); // Allow text to wrap
                            badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                            badge.style.setProperty(
                              "text-overflow",
                              "ellipsis",
                            ); // Add ellipsis if text overflows
                          }
                        }}
                      >
                        {episode?.status || "-"}
                      </Badge>
                    </td> */}
                    {location.pathname != "/Code-Assist-Episode-list" && (
                      <td className="episodelist-td">
                        {episode?.document_count > 0
                          ? episode?.document_count
                          : 0}
                      </td>
                    )}
                    {/* <td className='episodelist-td'> <Badge style={{ backgroundColor: `${episode?.status_color} !important`  || "#defaultColor !important" }}>{episode.status ? episode.status : "-"}</Badge></td> */}
                    {/* <td className='episodelist-td'>{episode.priority ? episode.priority : "N/A"}</td> */}
                  </tr>
                );
              })
            ) : (
              <td colspan="10" style={{ border: "none", height: "82vh" }}>
                {location.pathname === "/Code-Assist-Episode-list" ? (
                  <div className="episodelist-table-error">
                    Can’t find an episode? Use search to view all statuses. Only
                    Outstanding episodes are shown here
                  </div>
                ) : (
                  <div className="episodelist-table-error">
                    Can’t find an episode? Use search to view all statuses. Only
                    AI-processed episodes are shown here
                  </div>
                )}
              </td>
            )}
          </tbody>
        </Table>
      </div>
      <div className="episodelist-footer">
        <div>
          <Pagination className="episodelist-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={episodeListFilterObj?.page <= 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(episodeListFilterObj?.page - 1)}
              disabled={episodeListFilterObj?.page <= 1}
              className="episodelist-prev-btn"
            />
            <Pagination.Item>
              Page {episodeListFilterObj?.page} of {totalPages}
            </Pagination.Item>

            <Pagination.Next
              onClick={() => handlePageChange(episodeListFilterObj?.page + 1)}
              disabled={episodeListFilterObj?.page >= totalPages}
              className="episodelist-next-btn"
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={episodeListFilterObj.page === totalPages}
            />
          </Pagination>
        </div>
        <div className="episodelist-row-options">
          <Form.Select
            className="episodelist-select"
            value={episodeListFilterObj.page_size}
            onChange={handleRowsPerPageChange}
          >
            <option value="" disabled className="episodelist-rows-per-page">
              Rows per page
            </option>
            {/* <option value={10} className="episodelist-rows-per-page">10</option> */}
            <option value={20} className="episodelist-rows-per-page">
              20
            </option>
            <option value={50} className="episodelist-rows-per-page">
              50
            </option>
            <option value={100} className="episodelist-rows-per-page">
              100
            </option>
          </Form.Select>
        </div>
      </div>
      <EpisodeListFilter
        showepisodeListFilter={showepisodeListFilter}
        setShowepisodeListFilter={setShowepisodeListFilter}
        closeEpisodeFilterModal={closeEpisodeFilterModal}
        setCoderSearchTerm={setCoderSearchTerm}
      />
    </div>
  );
};

export default EpisodeList;
